import axiosService from '@Lib/axiosService';

const url = `${process.env.URL}`;

export const accessPermissions = ({ projectId }) => {
  return axiosService.get(`${url}/projects/${projectId}/accessPermissions`).then((res) => res.data);
};
